import React from 'react';
import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';

type Props = {
  year: number;
  goToNextYear: () => void;
  goToPrevYear: () => void;
};

const YearNav: React.FC<React.PropsWithChildren<Props>> = ({
  year,
  goToNextYear,
  goToPrevYear,
}) => {
  return (
    <ButtonGroup className="bg-gray rounded p-1">
      <Button size="sm" variant="gray" onClick={goToPrevYear}>
        ← {year - 1}
      </Button>
      <Button size="sm" variant="white" className="rounded">
        {year}
      </Button>
      <Button size="sm" variant="gray" onClick={goToNextYear}>
        {year + 1} →
      </Button>
    </ButtonGroup>
  );
};

export default YearNav;
